module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_1@3x.c63656c9.png";